import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import Button from 'components/forms/button/Button'

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const wrapMQ = css(mq({
  padding: [
    "40px 0 56px", // 0+
    "40px 0 56px", // 440+
    "64px 0 56px", // 768+
    "64px 0 0", // 1024+
    "64px 0 0", // 1200+
    "124px 0 50px", // 1400+
  ],
}))

export const Wrap = styled.div`
  display: flex;
  z-index: 1;
  background: var(--color-grayscale-950);
  ${wrapMQ}
`

const contentMQ = css(mq({
  gridTemplateColumns: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "292px 1fr", // 1024+
    "292px 1fr", // 1200+
    "1fr 380px", // 1400+
  ],
  justifyContent: [
    "center", // 0+
    "center", // 440+
    "center", // 768+
    "normal", // 1024+
    "normal", // 1200+
    "noraml", // 1400+
  ],
  gap: [
    44, // 0+
    44, // 440+
    44, // 768+
    80, // 1024+
    80, // 1200+
    64, // 1400+
  ],
  borderRadius: [
    0, // 0+
    0, // 440+
    24, // 768+
    24, // 1024+
    24, // 1200+
    0, // 1400+
  ],
  padding: [
    0, // 0+
    0, // 440+
    "16px 34px 56px", // 768+
    56, // 1024+
    56, // 1200+
    0, // 1400+
  ],
  maxWidth: [
    "calc(100vw - (48px * 2))", // 0+
    "calc(100vw - (48px * 2))", // 440+
    "calc(100vw - (80px * 2))", // 768+
    "calc(100vw - (80px * 2))", // 1024+
    "calc(100vw - (80px * 2))", // 1200+
    "auto", // 1400+
  ],
  background: [
    "none", // 0+
    "none", // 440+
    "#2C2F32", // 768+
    "#2C2F32", // 1024+
    "#2C2F32", // 1200+
    "none", // 1400+
  ],
}))

export const Content = styled.div`
  display: grid;
  width: 1260px;
  margin: 0 auto;
  ${contentMQ}
`

const messageBlockMQ = css(mq({
  order: [
    1, // 0+
    1, // 440+
    1, // 768+
    1, // 1024+
    1, // 1200+
    "unset", // 1400+
  ],
  background: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "none", // 1200+
    "#2C2F32", // 1400+
  ],
  padding: [
    0, // 0+
    0, // 440+
    0, // 768+
    0, // 1024+
    0, // 1200+
    56, // 1400+
  ],
  alignItems: [
    "center", // 0+
    "center", // 440+
    "center", // 768+
    "start", // 1024+
  ],
  textAlign: [
    "center", // 0+
    "center", // 440+
    "center", // 768+
    "left", // 1024+
  ],
}))

export const MessageBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  border-radius: 24px;
  ${messageBlockMQ}
`

const messageWrapMQ = css(mq({
  width: [
    "auto", // 0+
    420, // 440+
    540, // 768+
    "auto", // 1024+
    "auto", // 1200+
    540, // 1400+
  ],
  maxWidth: [
    "auto", // 0+
    "calc(100vw - (48px * 2))", // 440+
    "calc(100vw - (80px * 2))", // 768+
    "calc(100vw - (80px * 2))", // 1024+
    "calc(100vw - (80px * 2))", // 1200+
    "auto", // 1400+
  ],
}))

export const MessageWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${messageWrapMQ}
`

const titleMQ = css(mq({
  font: [
    "var(--accent-770)", // 0+
    "var(--accent-770)", // 440+
    "var(--accent-870)", // 768+
    "var(--accent-970)", // 1024+
  ],
}))

export const Title = styled.h2`
  color: var(--color-white);
  ${titleMQ}
`

const messageMQ = css(mq({
  font: [
    "var(--text-340)", // 0+
    "var(--text-340)", // 440+
    "var(--text-540)", // 768+
    "var(--text-640)", // 1024+
  ],
}))

export const Message = styled.p`
  color: var(--color-grayscale-100);
  ${messageMQ}
`

const imageBlockMQ = css(mq({
  padding: [
    24, // 0+
    24, // 440+
    0, // 768+
    0, // 1024+
    0, // 1200+
    44, // 1400+
  ],
  borderRadius: [
    20, // 0+
    20, // 440+
    0, // 768+
    0, // 1024+
    0, // 1200+
    24, // 1400+
  ],
}))

export const ImageBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2D3033;

  & > img {
    max-width: 100%;
    height: auto;
  }
  ${imageBlockMQ}
`

const bookButtonMQ = css(mq({
  font: [
    "var(--text-550)",
    "var(--text-550)",
    "var(--text-650)",
  ],
  borderRadius: [
    10,
    10,
    14,
  ],
  height: [
    48,
    48,
    64,
  ],
}))

export const BookButton = styled(Button)`
  ${bookButtonMQ}
`
